import { AccountManageClient } from '@app/api2/api';

// Create a singleton instance of the UserManageClient
export const userManageClient = new AccountManageClient();

export default userManageClient;